import { useEffect, useRef, useState } from "react";
import { LoaderCircle, Square, Volume2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

let currentAudio = null;

export const SpeakButton = ({ text, className = "" }) => {
  const [state, setState] = useState("idle");
  const audioRef = useRef(null);
  const urlRef = useRef(null);

  useEffect(() => () => {
    if (audioRef.current) audioRef.current.pause();
    if (urlRef.current) URL.revokeObjectURL(urlRef.current);
  }, []);

  const toggle = async () => {
    if (state === "loading") return;
    if (state === "playing") {
      audioRef.current?.pause();
      audioRef.current = null;
      setState("idle");
      return;
    }
    setState("loading");
    try {
      const res = await api.post("/tts", { text: text.slice(0, 4096) }, { responseType: "blob" });
      if (currentAudio) currentAudio.pause();
      if (urlRef.current) URL.revokeObjectURL(urlRef.current);
      const url = URL.createObjectURL(res.data);
      urlRef.current = url;
      const audio = new Audio(url);
      audioRef.current = audio;
      currentAudio = audio;
      audio.onended = () => setState("idle");
      await audio.play();
      setState("playing");
    } catch {
      toast.error("Lecture vocale indisponible. Veuillez réessayer.");
      setState("idle");
    }
  };

  return (
    <button type="button" onClick={toggle} aria-label={state === "playing" ? "Arrêter la lecture" : "Écouter"}
      className={`flex items-center gap-1.5 rounded-full border border-slate-200 px-3.5 py-1.5 text-[11px] font-semibold text-slate-600 transition-colors hover:border-bleu/40 hover:text-bleu ${className}`}
      data-testid="speak-button">
      {state === "loading" ? <LoaderCircle className="h-3 w-3 animate-spin" />
        : state === "playing" ? <Square className="h-3 w-3" /> : <Volume2 className="h-3 w-3" />}
      {state === "playing" ? "Arrêter" : "Écouter"}
    </button>
  );
};
